import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMUC } from 'src/app/models/crm/crmuc';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmucService } from 'src/app/services/crm/crmuc.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-cadastrar-uc',
  templateUrl: './cadastrar-uc.component.html',
  styleUrls: ['./cadastrar-uc.component.scss']
})
export class CadastrarUcComponent implements OnInit {
  // variáveis
  idCRMUC;
  idOportunidade;
  uc = new CRMUC();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  public config: PerfectScrollbarConfigInterface = {};
  selectedFile: File;
  nomeArquivoBanco = '';
  
  constructor(
    private notificacaoService: NotificacaoService,
    private ucService: CrmucService, private utilitarioService: UtilitarioService,
    private router: Router, public dialog: MatDialog,
    private globalService: GlobalService, private carregandoService: CarregandoService,
    public dialogRef: MatDialogRef<CadastrarUcComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.idCRMUC = data.id;
    this.idOportunidade = data.idOportunidade;
  }

  ngOnInit() {
    // se for edição, busca o uc do id passado
    if (this.idCRMUC) {
      this.editando = true;
      this.buscarCRMUC();
    } else {
      this.uc = new CRMUC();
      this.uc.tipo = 1;
      this.atualizaDadosCRMUC();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarCRMUC() {
    this.carregandoService.mostra('buscaCRMUC');

    this.ucService.consultarPorIdUC(this.idCRMUC).subscribe(uc => {
      this.uc = uc;
      this.atualizaDadosCRMUC();
    }, (erro) => {
      this.carregandoService.esconde('buscaCRMUC');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosCRMUC() {
    this.carregando = false;

    this.carregandoService.esconde('buscaCRMUC');
  }

  salvar() {
    this.carregandoService.mostra('salvaCRMUC');

    this.uc.idOportunidade = Number(this.idOportunidade);
    this.uc.tipo = Number(this.uc.tipo);

    this.ucService.salvar(this.uc).subscribe(() => {
      this.notificacaoService.sucesso('Nº da Instalação Recebedora salvo com sucesso!!!');
      this.carregandoService.esconde('salvaCRMUC');
      this.dialogRef.close(true);

    }, (erro) => {
      this.carregandoService.esconde('salvaCRMUC');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {}

  fechar() {
    this.dialogRef.close();
  }
}